<template>
    <div class="form-group">
        <label class="label required">{{ label  }}</label>
        <app-input 
            type="text"
            v-model="displayData"
            :placeholder="'Value'"
            :required="true"
            @input="updateValue"
            :disabled="is_view"
            @blur="rawInputData = ''"
        />
    </div>
</template>

<script>
export default {
    name: 'CVForduties',
    props: {
        label : {
            type : String,
            default : '',
        },
        value: {
            type: Object,
            default: () => ({
                value: ''
            })
        },
        is_view : {
            type : Boolean,
            default : false,
        }
    },
    data() {
        return {
            isTypingDotData: false,
            rawInputData: '', 
            isTypingDot: false,
            rawInput: '',
            internalValue: { ...this.value }
        };
    },
    watch: {
        value: {
            handler(newValue) {
                this.internalValue = { ...newValue };
            },
            deep: true
        }
    },
    computed : {
        displayData: {
            get() {
                const val = this.internalValue.value;
                if (val === null || val === '') return this.rawInputData || '$ 0';

                // Si el usuario está escribiendo, mostramos el raw
                if (this.rawInputData !== '') return '$ ' + this.rawInputData;

                return '$ ' + new Intl.NumberFormat('en-US').format(val);
            },
            set(newValue) {
                const cleanValue = newValue.replace(/[^0-9.]/g, '');
                this.rawInputData = cleanValue;  // guardamos el string tal cual

                if (cleanValue.endsWith('.')) {
                    this.isTypingDotData = true;
                    return;
                }

                this.isTypingDotData = false;

                const numericValue = cleanValue === '' ? null : parseFloat(cleanValue);

                if (!isNaN(numericValue) || cleanValue === '') {
                    this.internalValue.value = numericValue;
                    this.updateValue();
                }
            }
        },
    },
    methods: {
        updateValue() {
            this.$emit('input', { ...this.internalValue });
        }
    }
}
</script>

<style scoped>
    .label {
        font-weight: 600;
    }
    .row {
        margin-left: 0;
        margin-right: 0;
    }
</style>